/**
 * 智投创编工作台菜单码与侧栏/路由守卫一致：
 * 后端若暂未下发 smart-create-hub，只要已有任一下层权限则补全，避免「能进页但侧栏无入口、高亮错位」。
 */
export const SMART_CREATE_HUB_FALLBACK_CODES = [
  'targeting-package',
  'targeting-config',
  'dmp-audience',
  'hap-link',
  'product-creative-config',
  'create-intent',
  'auto-create-rule',
  'auto-create-schedule',
  'bidding-policy'
]

export function ensureSmartHubInMenuList(menus) {
  if (!Array.isArray(menus)) return []
  if (menus.length === 0) return menus
  if (menus.indexOf('smart-create-hub') !== -1) return menus
  if (!SMART_CREATE_HUB_FALLBACK_CODES.some(c => menus.indexOf(c) !== -1)) return menus
  return menus.concat(['smart-create-hub'])
}

/**
 * 从 localStorage 同步读出上次登录写入的菜单码（经 ensureSmartHubInMenuList），供 Layout 首屏 data() 使用，
 * 避免刷新时 allowedMenus 先为空：当前口径空列表=无权限（侧栏不展示），就绪后再按叶子码渲染。
 */
export function readAllowedMenusFromStorage() {
  try {
    const raw = localStorage.getItem('allowedMenus')
    if (!raw) return []
    const arr = JSON.parse(raw)
    if (!Array.isArray(arr)) return []
    return ensureSmartHubInMenuList(arr.slice())
  } catch (e) {
    return []
  }
}
